import React from 'react';
import Modal from 'react-modal';

import './confirmationModal.css';

interface ConfirmationModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onConfirm: () => void;
}

const BackModal: React.FC<ConfirmationModalProps> = ({ isOpen, onRequestClose, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} contentLabel="Confirm Modal" className="confirmModal" overlayClassName="overlay">
      <div className="confirmModal-header">
        <button onClick={onRequestClose} type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Cerrar"></button>
      </div>
      <div className="confirmModal-body">
        <p>Si regresa, la hora que ha seleccionado quedará disponible para que otras personas la puedan tomar</p>
      </div>
      <div className="confirmModal-footer">
        <button onClick={onRequestClose}>Cancelar</button>
        <button onClick={onConfirm}>Confirmar</button>
      </div>
    </Modal>
  );
};

export default BackModal;
